import { Directive, ElementRef, HostListener, Optional, Self } from "@angular/core";
import { NgControl, ControlValueAccessor } from "@angular/forms";


class NullConverterValueAccessor implements ControlValueAccessor {

  private propagateChange = (_: unknown) => { };

  private onControlChange = (value: unknown) => {
    const translatedValue = (value === '' || value === undefined) ? null : value;
    this.propagateChange(translatedValue);
  }

  constructor(private innerAccessor: ControlValueAccessor) {
    this.innerAccessor.registerOnChange(this.onControlChange);
  }

  writeValue(obj: unknown): void {
    this.innerAccessor.writeValue(obj);
  }
  registerOnChange(fn: unknown): void {
    this.propagateChange = fn as any;
  }
  registerOnTouched(fn: unknown): void {
    this.innerAccessor.registerOnTouched(fn);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.innerAccessor.setDisabledState(isDisabled);
  }
}

@Directive({
    //selector: 'input[emptyToNull]'
    selector: 'input:not([type])[ngModel],input[type=text][ngModel],input[type=password][ngModel],input[type=email][ngModel],input[type=tel][ngModel],textarea[ngModel]',
    standalone: false
})
export class EmptyToNullDirective {

  private valueAccessor: NullConverterValueAccessor;

  constructor(private el: ElementRef, @Self() @Optional() private ngControl: NgControl) {

    if (ngControl === undefined)
      return;

    this.ngControl.valueAccessor = this.valueAccessor = new NullConverterValueAccessor(this.ngControl.valueAccessor);
  }
}
